import type { AutocompleteProps, AutocompleteValue, TextFieldProps } from '@mui/material';
import CheckboxAutocomplete from 'components/common/CheckboxAutocomplete';
import type { OptionValue } from 'components/common/CheckboxAutocomplete';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAdCompaniesOptions } from '../api/getAdCompanies';
import useFacebookAdsLibraryParams from '../hooks/useFacebookAdsLibraryParams';

interface GoogleCompanyAutocompleteProps
  extends Omit<AutocompleteProps<number, true, boolean, false>, 'value' | 'onChange' | 'options' | 'renderInput'> {
  value?: AutocompleteValue<number, true, false, false>;
  onChange: (value: AutocompleteValue<number, true, false, false>) => void;
  InputProps?: TextFieldProps;
  allowedValues: number[];
}

const GoogleCompanyAutocomplete = ({
  InputProps,
  value,
  onChange,
  allowedValues,
  ...props
}: GoogleCompanyAutocompleteProps) => {
  const { network, region } = useFacebookAdsLibraryParams();
  const { data } = useSuspenseQuery({
    ...getAdCompaniesOptions({ network, region }),
    select: (data) =>
      data
        .map(({ id, name }) => ({ label: name, value: id }))
        .filter(({ value: optionValue }) => allowedValues.includes(optionValue)),
  });

  return (
    <CheckboxAutocomplete
      {...props}
      value={value}
      onChange={onChange as (value: OptionValue[]) => void}
      InputProps={InputProps}
      id="google-company-autocomplete"
      options={data}
    />
  );
};

export default GoogleCompanyAutocomplete;
